import { redirectToLogin, Auth } from '@core/auth';
import { isPublic } from '@core/router/utils';

const loadUser = async (to, from, next) => {
    if (isPublic(to) || Auth().onboarding) {
        next();
    } else {
        try {
            await Auth().setCurrentUser();

            if (to.name && to.name.startsWith('InvestorOnboarding')) {
                next({ name: 'SettingsProfile' });
            } else {
                next();
            }
        } catch (error) {
            const httpStatus = error?.response?.status;

            if (httpStatus === 404) {
                await Auth().setRegistration();
                next();
            } else if (httpStatus < 500) {
                return redirectToLogin({
                    rd: window.location.href,
                    app_uri: window.location.host
                });
            }
        }
    }
};

export default loadUser;
